'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getIn;

var _get2 = require('./_get');

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getIn(keyPath, subject) {
  var value = subject;
  for (var i = 0; i < keyPath.length; i++) {
    if (value === undefined) {
      break;
    }
    value = (0, _get3.default)(keyPath[i], value);
  }
  return value;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_getIn.js
// module id = 180
// module chunks = 0 1